<template>
  <div class="wrapper" :class="{ 'nav-open': $sidebar.showSidebar }">
    <notifications></notifications>

    <side-bar
      :sidebar-item-color="sidebarBackground"
      :sidebar-background-image="sidebarBackgroundImage"
    >
      <mobile-menu slot="content"></mobile-menu>
      <sidebar-link to="/dashboard">
        <md-icon>dashboard</md-icon>
        <p>Dashboard</p>
      </sidebar-link>
      <sidebar-link to="/task-management">
        <md-icon>task</md-icon>
        <p>Team Tasks</p>
      </sidebar-link>
      <!-- <sidebar-link to="/task-assign">
        <md-icon>person</md-icon>
        <p>To-Do Assignment</p>
      </sidebar-link> -->
      <sidebar-link to="/my-task-management">
        <md-icon>task</md-icon>
        <p>My Tasks</p>
      </sidebar-link>
      <sidebar-link to="/my-profile">
        <md-icon>person</md-icon>
        <p>My Profile</p>
      </sidebar-link>
      <sidebar-link to="/user-management">
        <!-- <md-icon>person</md-icon> -->
        <i class="fas fa-users" style="color:#fff;opacity:0.8;"></i>
        <p>Users Management</p>
      </sidebar-link>
      <sidebar-link to="/Category">
        <md-icon>category</md-icon>
        <p>Task Category</p>
      </sidebar-link>
      <sidebar-link to="/change-password">
        <md-icon>password</md-icon>
        <p>Change Password</p>
      </sidebar-link>
      <sidebar-link @click="logout" to="/login">
        <md-icon @click="logout">logout</md-icon>
        <p @click="logout">Logout</p>
      </sidebar-link>
    </side-bar>

    <div class="main-panel">
      <top-navbar></top-navbar>
      <dashboard-content> </dashboard-content>

      <content-footer v-if="!$route.meta.hideFooter"></content-footer>
    </div>
  </div>
</template>

<script>
import TopNavbar from "./TopNavbar.vue";
import ContentFooter from "./ContentFooter.vue";
import DashboardContent from "./Content.vue";
import MobileMenu from "@/pages/Layout/MobileMenu.vue";
import { setAuthToken } from "../../components/apiConfig";

export default {
  components: {
    TopNavbar,
    DashboardContent,
    ContentFooter,
    MobileMenu,
  },
  data() {
    return {
      sidebarBackground: "green",
      sidebarBackgroundImage: require("@/assets/img/sidebar-2.jpg"),
    };
  },
  methods: {
    logout() {
      setAuthToken();
      //alert("Logout successfully.");
      this.$router.push("/login");
    },
  },
};
</script>
